import { CommitmentsScenariosVariantsService } from '@festina/life-general-types/life/services/CommitmentsScenariosVariantsService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method =
  CommitmentsScenariosVariantsService.commitmentScenarioVariantVersionServicePostCreateEntity
type MethodParam = Parameters<typeof method>[0]

export const useSubmitScenarioVariant = ({
  tenantId,
  ownerId,
}: {
  tenantId: string
  ownerId: string
}) =>
  useFestinaMutation({
    component: 'life',
    roles:
      CommitmentsScenariosVariantsService.commitmentScenarioVariantVersionServicePostCreateEntity_roles,
    isScenario: false,
    mutateFunction: async (arg: Except<MethodParam, 'ownerId' | 'xTenantId'>) =>
      await method({
        xTenantId: tenantId,
        ownerId,
        ...arg,
      }),
  })
